module.exports = __webpack_public_path__ + "static/gerdau-2a3f50d758298fc1d17f8bde1a62d75e.png";